import ManuscriptDefault from "../components/Manuscript/Default";
import StartManuscript from "../components/Manuscript/StartManuscript";
import ContinueManuscript from "../components/Manuscript/ContinueManuscript";
import SubmittedManuscripts from "../components/Manuscript/SubmittedManuscripts";
import IncompleteSubmissions from "../components/Manuscript/IncompleteSubmissions";
import TrackManuscript from "../components/Manuscript/TrackManuscript";
import ManuscriptVersions from "../components/Manuscript/ManuscriptVersions";

const routes = [
  {
    path: "/manuscripts",
    component: ManuscriptDefault,
    redirect: "/manuscripts/start",
    meta: {
      requiresAuth: true,
      description: "Manuscripts",
    },
    children: [
      {
        path: "start",
        name: "startManuscript",
        component: StartManuscript,
        meta: {
          requiresAuth: true,
          description: "Upload a manuscript",
        },
      },
      {
        path: "continue/:manuscriptId",
        name: "continueManuscript",
        component: ContinueManuscript,
        props: true,
        meta: {
          requiresAuth: true,
          description: "Continue with manuscript upload",
        },
      },
      {
        path: "submitted",
        name: "submittedManuscripts",
        component: SubmittedManuscripts,
        meta: {
          requiresAuth: true,
          description: "Manuscripts you have submitted",
        },
      },
      {
        path: "submitted/track/:manuscriptId",
        name: "trackManuscript",
        component: TrackManuscript,
        props: true,
        meta: {
          requiresAuth: true,
          description: "Track submitted manuscript",
        },
      },
      {
        path: "submitted/:folder",
        name: "manuscriptVersions",
        component: ManuscriptVersions,
        props: true,
        meta: {
          requiresAuth: true,
          description: "Manuscript versions",
        },
      },
      {
        path: "incomplete",
        name: "incompleteSubmissions",
        component: IncompleteSubmissions,
        meta: {
          requiresAuth: true,
          description: "Your manuscripts with incomplete submissions",
        },
      },
    ],
  },
];

export default routes;
